function formatPrice(priceValue) {
  return isNaN(priceValue) ? priceValue : priceValue.toFixed(2);
}

function generatePriceHTML(product) {
  // Filter by available variants only
  const availableVariants = product.variants?.filter(v => v.available) || [];
  const sortedAvailable = [...availableVariants].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
  const lowestAvailable = sortedAvailable[0];
  const highestAvailable = sortedAvailable[sortedAvailable.length - 1];

  const variant = lowestAvailable ?? product.variants?.[0] ?? null;
  const price = highestAvailable?.price ?? variant?.price ?? parseFloat(product?.price) ?? null;
  const compareAtPrice = lowestAvailable?.compareAtPrice ?? variant?.compareAtPrice ?? product?.compareAtPrice ?? "";
  const lowestVariantPrice = lowestAvailable?.price ?? "";
  
  if (price === 0) {
    return '<span class="price"></span>';
  } else if (lowestVariantPrice && lowestVariantPrice !== price && lowestVariantPrice !== "0" && lowestVariantPrice !== 0) {
    return '<span class="price price--highlight">' + formatPrice(lowestVariantPrice) + ' ₪ - ' + formatPrice(price) + ' ₪</span>';
  } else if (compareAtPrice && price < compareAtPrice) {
    return '<span class="price price--highlight">' + formatPrice(price) + ' ₪</span><span class="price price--compare">' + formatPrice(compareAtPrice) + ' ₪</span>';
  } else {
    return '<span class="price price--highlight">' + formatPrice(price) + ' ₪</span>';
  }
}
